import { observable, action } from 'mobx'
import Api from '@api/xi_feng/topicDetail'
import { message } from 'hljd'

class Store {
  @observable id = ''
  @observable activeTab = '1'
  @observable detailInfo = {}
  @observable noteList = []

  constructor(id) {
    this.id = id
  }

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  @action
  getTopicDetail = async () => {
    const { data } = await Api.getTopicDetail({ topic_id: this.id })
    // console.log(data)
    this.detailInfo = data
  }

  @action
  getNoteList = async () => {
    const { data } = await Api.getNoteList({
      topic_id: this.id,
      per_page: 10,
      page: 1
    })
    console.log(data)
    this.noteList = data.list
  }

  @action
  publish = async data => {
    const body = {
      content: data.content.replace(/(^\s*)|(\s*$)/g, ''),
      // inspirations: toJS(this.inspirations),
      marks: [],
      note_book_type: '4',
      note_type: data.type,
      title: data.title.replace(/(^\s*)|(\s*$)/g, ''),
      note_topic_id: this.id
    }
    if (data.type == '3') {
      body.inspirations = [
        {
          media: {
            type: 2,
            video: {
              height: data.uploadVideo.height,
              width: data.uploadVideo.width,
              origin_path: data.uploadVideo.link,
              persistent_id: data.uploadVideo.persistent_id,
              cover_path: data.uploadVideo.cover_path
            }
          }
        }
      ]
      if (data.videoTag) {
        body.marks = [{ id: data.videoTag }]
      }
    } else {
      body.inspirations = data.imgs
    }
    const { success } = await Api.publishNote(body)
    if (success) {
      message.success('发布成功')
      this.getNoteList()
    }
    // hashHistory.replace(`/localMerchant/dynamicDetail/${id}`)
  }
}

export default Store
